import Environment from '@/config/environment'
import api from '@/config/axios'
import type { AuthorizationRequest, AuthorizationResponse } from '@/types/auth.type'
import { auth } from '@/config/firebase'
import { signOut } from 'firebase/auth'

export const authorization = async (
  credentials: AuthorizationRequest
): Promise<AuthorizationResponse> => {
  const response = await api.get('/authorization')
  return response.data
}

export const getGoogleAuthUrl = async (): Promise<string> => {
  const response = await api.get('/authorization')

  if (!response?.data?.data || !response.data.data.includes('accounts.google.com')) {
    throw new Error('URL de autorização do Google não foi retornada')
  }

  return response.data.data
}

export const checkAuthStatus = async () => {
  const baseApi = Environment.BASE_API
  const response = await fetch(`${baseApi}/authStatus`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  if (!response.ok) {
    throw new Error('Not authenticated')
  }
  return await response.json()
}

export const logout = async (url: string | null = null) => {
  await signOut(auth)
  localStorage.clear()
  location.href = url ?? Environment.LOGIN_URL
}
